<template>
    <div v-if="list && typeof(list) == 'object'  && Object.values(this.$props.list).length && Object.values(this.$props.list).length > 2" class="container fl-pdf" ref="htmlBody">
        <div class="pdf__article">
            <corpIcon style="max-height: 52px;"/>
            <p style="display: inline-block; width: 80%" class="pdf__article__text">Отчет по результатам онлайн-проверки физического лица<br> по открытым реестрам данных на {{dateParser(dateCheck)}}</p>
        </div>
        <div class="pdf__main-info">
            <div class="pdf__header" style="width: 17%;">ИСХОДНЫЕ ДАННЫЕ</div>
            <hr style="margin: 0 0 10px"/>
            <p class="pdf__main-info__text" v-if="name && patronymic && surname">ФИО: <span style="margin-left: 82px" class="pdf__main-info__text_bold">{{nameOfPerson}}</span></p>
            <p class="pdf__main-info__text" v-if="birthday">Дата рождения: <span class="pdf__main-info__text_bold">{{dateParser(birthday)}}</span></p>
            <p class="pdf__main-info__text" v-if="serial && number">Паспорт: <span style="margin-left: 55px" class="pdf__main-info__text_bold">{{serial}} {{number}}</span></p>
            <p class="pdf__main-info__text" v-if="inputInn">ИНН ФЛ: <span style="margin-left: 58px" class="pdf__main-info__text_bold">{{inputInn}}</span></p>
        </div>
        <div class="pdf__short-version">
            <div class="pdf__header" style="width: 27%;">РЕЗУЛЬТАТ ПРОВЕРКИ (краткий)</div>
            <hr style="margin: 0 0 10px"/>
            <a :class="{'grey': isPassportsError }" href="#passport" class="pdf__short-version__text">
                <i v-if="!isPassportsError && !isPassportsData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isPassportsError}" class="fas fa-times"></i>Проверка паспорта
            </a>
            <a :class="{'grey': isCheckInnError }" href="#inn" class="pdf__short-version__text">
                <i v-if="!isCheckInnError && checkInnCode == 1" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isCheckInnError}" class="fas fa-times"></i>Проверка ИНН
            </a>
            <a :class="{'grey': isFedRozyskError}" href="#fed" class="pdf__short-version__text">
                <i v-if="!isFedRozyskError && !isFedRozyskData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isFedRozyskError}" class="fas fa-times"></i>Реестр федерального розыска МВД РФ
            </a>
            <a :class="{'grey': isTerroristsError}" href="#terrorist" class="pdf__short-version__text">
                <i v-if="!isTerroristsError && !isTerroristsData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isTerroristsError}" class="fas fa-times"></i>Реестр террористов/экстремистов
            </a>
            <a :class="{'grey': isFsinError}" href="#fsin" class="pdf__short-version__text">
                <i v-if="!isFsinError && !isFsinData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isFsinError}" class="fas fa-times"></i>Реестр розыска ФСИН
            </a>
            <a :class="{'grey': isFsspFlRozyskYkError}" href="#fssp_yk" class="pdf__short-version__text">
                <i v-if="!isFsspFlRozyskYkError && !isFsspFlRozyskYkData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isFsspFlRozyskYkError}" class="fas fa-times"></i>Реестр розыска ФССП (совершенные преступления)
            </a>
            <a :class="{'grey': isFsspFlRozyskIpError}" href="#fssp_ip" class="pdf__short-version__text">
                <i v-if="!isFsspFlRozyskIpError && !isFsspFlRozyskIpData" class="fas fa-check"></i>
                <i v-else :class="{'hidden' : isFsspFlRozyskIpError}" class="fas fa-times"></i>Реестр розыска ФССП (по исполнительным производствам)
            </a>
            <a :class="{'grey': isFsspFlIpError}" href="#fssp" class="pdf__short-version__text">
                <i v-if="!isFsspFlIpError && !isFsspFlIpData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isFsspFlIpError}" class="fas fa-times"></i>Банк данных исполнительных производств ФССП
            </a>
            <a :class="{'grey': isBankruptError}" href="#bankrupt" class="pdf__short-version__text">
                <i v-if="!isBankruptError && !isBankruptData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isBankruptError}" class="fas fa-times"></i>Реестр банкротств физических лиц
            </a>
            <a :class="{'grey': isDismissedPersonError}" href="#fired" class="pdf__short-version__text">
                <i v-if="!isDismissedPersonError && !isDismissedPersonData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isDismissedPersonError}" class="fas fa-times"></i>Реестр лиц, уволенных в связи с утратой доверия
            </a>
            <a :class="{'grey': isNedoimkiError}" href="#nedoimki" class="pdf__short-version__text">
                <i v-if="!isNedoimkiError && !isNedoimkiData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isNedoimkiError}" class="fas fa-times"></i>Налоговая задолженность ФЛ
            </a>
            <a :class="{'grey': isPledgeError}" href="#pledge" class="pdf__short-version__text">
                <i v-if="!isPledgeError && !isPledgeData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isPledgeError}" class="fas fa-times"></i>Реестр залогов движимого имущества
            </a>
            <a :class="{'grey': isDisqPersonError}" href="#disq" class="pdf__short-version__text">
                <i v-if="!isDisqPersonError && !isDisqPersonData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isDisqPersonError}" class="fas fa-times"></i>Реестр дисквалифицированных лиц ФНС РОССИИ
            </a>
            <a :class="{'grey': isRestrictOnPartUlErorr}" href="#restrict" class="pdf__short-version__text">
                <i v-if="!isRestrictOnPartUlErorr && !isRestrictOnPartUlData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isRestrictOnPartUlErorr}" class="fas fa-times"></i>Реестр ограничений участия в ЮЛ ФНС РОССИИ
            </a>
            <a :class="{'grey': isCheckIpError}" href="#ip" class="pdf__short-version__text">
                <i v-if="!isCheckIpError && isCheckIpData" class="fas fa-plus"></i>
                <i v-else :class="{'hidden': isCheckIpError}" class="fas fa-minus"></i>Наличие статуса ИП
            </a>
            <a :class="{'grey':isSelfEmployedError}" href="#employed" class="pdf__short-version__text">
                <i v-if="!isSelfEmployedError && isSelfEmployedData" class="fas fa-plus"></i>
                <i v-else :class="{'hidden': isSelfEmployedError}" class="fas fa-minus"></i>Наличие статуса самозанятого
            </a>
            <a :class="{'grey': isMassPersonError}" href="#mass_upr" class="pdf__short-version__text">
                <i v-if="!isMassPersonError && !isMassPersonUprData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isMassPersonError}" class="fas fa-times"></i>Реестр массовых руководителей
            </a>
            <a :class="{'grey': isMassPersonError}" href="#mass_uchr" class="pdf__short-version__text">
                <i v-if="!isMassPersonError && !isMassPersonUchrData" class="fas fa-check"></i>
                <i v-else :class="{'hidden': isMassPersonError}" class="fas fa-times"></i>Реестр массовых учредителей
            </a>
            <a :class="{'grey': isAffilError}" href="#affil" class="pdf__short-version__text">
                <i v-if="!isAffilError && isAffilData" class="fas fa-plus"></i>
                <i v-else :class="{'hidden': isAffilError}" class="fas fa-minus"></i>Аффилированные структуры
            </a>
        </div>
        <div class="pdf__long-version">
            <div class="pdf__header" style="width: 36%;" >РЕЗУЛЬТАТ ПРОВЕРКИ (детализированный)</div>
            <div v-if="!isPassportsError">
                <i v-if="!isPassportsData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header" style="margin-top: 5px;" id="passport">ПРОВЕРКА ПАСПОРТА</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным ГУВМ МВД на {{dateParser(dateCheck)}} года паспорт {{serial}} {{number}} 
                    <span v-if="!isPassportsData" class="green">действителен</span>
                    <span v-else class="red">не действителен</span>.
                </p>
            </div>
            <div v-if="!isCheckInnError" id="inn">
                <i v-if="checkInnCode == 1"  class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">ПРОВЕРКА ИНН</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="checkInnCode == 1" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="green">зарегистрирован(а)</span> в качестве налогоплательщика с ИНН {{list.check_inn.data.inn}}. Регион первичной регистрации налогоплательщика: {{getRegionByInn(list.check_inn.data.inn)}}.
                </p>
                <p v-else class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="red">не зарегистрирован(а)</span> в качестве налогоплательщика.
                </p>
            </div>
            <div v-if="!isFedRozyskError" id="fed">
                <i v-if="!isFedRozyskData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ФЕДЕРАЛЬНОГО РОЗЫСКА МВД</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным МВД РФ на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isFedRozyskData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре федерального розыска.
                </p>
                <div v-if="isFedRozyskData">
                    <div v-for="(r,i) in list.fed_rozysk.data.find_obj" :key="i">  
                        <p style="margin: 5px 0;">
                            <img :src="r.url_img" style="width: 100px" />
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="!isTerroristsError" id="terrorist">
                <i v-if="!isTerroristsData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ТЕРРОРИСТОВ/ЭКСТРЕМИСТОВ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="!isTerroristsData" class="pdf__long-version__text">
                    По данным Росфинмониторинг на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="green">не состоит</span> в реестре террористов/экстремистов.
                </p>
                <p v-else class="pdf__long-version__text">
                    По данным Росфинмониторинг на {{dateParser(dateCheck)}} года {{nameOfPerson}}{{dateParser(list.terrorists.data.terrorists[0].bday) ? `, ${dateParser(list.terrorists.data.terrorists[0].bday)}` : ''}}{{list.terrorists.data.terrorists[0].address ? `, ${list.terrorists.data.terrorists[0].address}` : ''}} <span v-if="isTerroristsData" class="red">состоит</span> в реестре террористов/экстремистов.
                </p>
            </div>
            <div v-if="!isFsinError" id="fsin">
                <i v-if="!isFsinData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР РОЗЫСКА ФСИН</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным ФСИН  на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isFsinData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре розыска ФСИН.
                </p>
            </div>
            <div v-if="!isFsspFlRozyskYkError"  id="fssp_yk">
                <i v-if="!isFsspFlRozyskYkData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР РОЗЫСКА ФССП (совершенные преступления)</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным ФССП   на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isFsspFlRozyskYkData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре розыска по подозрению в совершении преступлений.
                </p>
                <div v-if="isFsspFlRozyskYkData">
                    <div v-for="(y,i) in list.fssp_fl_rozysk_yk.data" :key="i" style="font-size: 12px; margin: 10px 0">
                        <div>
                            <b>Адрес проживания:</b>
                            <span>{{y.address}}</span>
                        </div>
                        <div>
                            <b>Орган инициировавший розыск:</b>
                            <span>{{y.name_org_initiating}}</span>
                        </div>
                        <div>
                            <b>Орган осуществляющий розыск:</b>
                            <span>{{y.name_org_initiates}}</span>
                        </div>
                        <div>
                            <b>Статья:</b>
                            <span>{{y.statya}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isFsspFlRozyskIpError"  id="fssp_ip">
                <i v-if="!isFsspFlRozyskIpData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР РОЗЫСКА ФССП (по исполнительным производствам)</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным ФССП на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isFsspFlRozyskIpData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре розыска по подозрению в совершении преступлений.
                </p>
                <div v-if="isFsspFlRozyskIpData">
                    <div v-for="(f,i) in list.fssp_fl_rozysk_ip.data.result" :key="i" style="font-size: 12px; margin: 10px 0">
                        <div>
                            <span v-if="f.ip_date">{{f.ip_date}}</span>
                            <span v-if="f.ip_number" style="font-size: 14px">{{f.ip_number}}</span>
                        </div>
                        <div v-if="f.delo_number">
                            <b>Номер дела:</b>
                            <span>{{f.delo_number}}</span>
                        </div>
                        <div v-if="f.otdel_fssp">
                            <b>Адрес отдела:</b>
                            <span>{{f.otdel_fssp}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isFsspFlIpError"  id="fssp">
                <i v-if="!isFsspFlIpData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">БАНК ДАННЫХ ИСПОЛНИТЕЛЬНЫХ ПРОИЗВОДСТВ ФССП</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isFsspFlIpData" class="pdf__long-version__text">
                    По данным ФССП на {{dateParser(dateCheck)}} года в отношении {{nameOfPerson}} <span class="red">имеются</span> следующие возбужденные исполнительные производства:
                </p>
                <p v-else class="pdf__long-version__text">
                    По данным ФССП на {{dateParser(dateCheck)}} года в отношении {{nameOfPerson}} <span class="green">отсутствуют </span> возбужденные исполнительные производства.
                </p>
                <div v-if="isFsspFlIpData">
                    <div v-for="(z,i) in list.fssp_fl_ip.data.result" :key="i" class="pdf__long-version__box">
                        <p v-if="z.ip_number && z.ip_date"><span class="pdf__long-version__text_bold">Исполнительное производство №</span> {{z.ip_number}} от {{z.ip_date}}</p>
                        <p><span class="pdf__long-version__text_bold">Стадия исполнения:</span> {{z.date_end ? 'Окончено' : 'Открыто'}}</p>
                        <p v-if="z.ip_info"><span class="pdf__long-version__text_bold">Предмет исполнения:</span> {{z.ip_info}}</p>
                        <p v-if="z.info_doc"><span class="pdf__long-version__text_bold">Номер исполнительного документа:</span> {{z.info_doc}}</p>
                        <p v-if="z.summ"><span class="pdf__long-version__text_bold">Сумма задолженности:</span> {{z.summ}} руб</p>
                        <p v-if="z.otdel_fssp"><span class="pdf__long-version__text_bold">Адрес отдела судебных приставов:</span> {{z.otdel_fssp}}</p>
                    </div>
                    <p class="pdf__long-version__text_bold" style="font-size: 12px; margin: 30px 0 0 15px; text-decoration: underline">Общее количество исполнительных производств: {{list.fssp_fl_ip.data.result.length}}</p>
                    <p class="pdf__long-version__text_bold" style="font-size: 12px; margin: 0 0 30px 15px; text-decoration: underline">Общая сумма задолженности: {{getSum(list.fssp_fl_ip.data.result, 'ip').toFixed(2)}} руб</p>
                </div>
            </div>
            <div v-if="!isBankruptError"  id="bankrupt">
                <i v-if="!isBankruptData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР БАНКРОТСТВ ФИЗИЧЕСКИХ ЛИЦ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="!isBankruptError" class="pdf__long-version__text">
                    По данным ЕФРСБ на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isBankruptData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре банкротств.
                </p>
                <p v-else-if="list.bankrupt.status == 'not valid'">{{list.bankrupt.message}}</p>
                <div v-if="isBankruptData">
                    <p class="pdf__long-version__text" v-if="list.bankrupt.data.type_text" ><span class="pdf__long-version__text_bold">Стадия банкротства: </span>{{list.bankrupt.data.type_text}}</p>
                    <p class="pdf__long-version__text" v-if="list.bankrupt.data.number_dela"><span class="pdf__long-version__text_bold">№ судебного дела: </span>{{list.bankrupt.data.number_dela}}</p>
                    <p class="pdf__long-version__text" v-if="list.bankrupt.data.start_message_data.text"><span class="pdf__long-version__text_bold">Основание:</span> {{list.bankrupt.data.start_message_data.text}}</p>
                </div>
            </div>
            <div v-if="!isDismissedPersonError"  id="fired">
                <i v-if="!isDismissedPersonData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ЛИЦ, УВОЛЕННЫХ В СВЯЗИ С УТРАТОЙ ДОВЕРИЯ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным системы государственной службы на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span v-if="isDismissedPersonData" class="red">состоит</span>
                    <span v-else class="green">не состоит</span> в реестре лиц, уволенных в связи с утратой доверия.
                </p>
                <div v-if="isDismissedPersonData">
                    <div v-for="(dis,i) in list.dismissed_person.data" :key="i" class="pdf__long-version__box">
                        <p class="pdf__long-version__text" v-if="dis.organization"><span class="pdf__long-version__text_bold">Наименование органа (организации):</span> {{dis.organization}}</p>
                        <p class="pdf__long-version__text" v-if="dis.position"><span class="pdf__long-version__text_bold">Должность:</span> {{dis.position}}</p>
                        <p class="pdf__long-version__text" v-if="dis.violation"><span class="pdf__long-version__text_bold">Основание увольнения: </span> {{dis.violation}}</p>
                        <p class="pdf__long-version__text" v-if="dis.dismissal_date"><span class="pdf__long-version__text_bold">Дата увольнения: </span> {{dis.dismissal_date}}</p>
                    </div>
                    <p class="pdf__long-version__text_tip">*Поиск в реестре осуществляется по ФИО физического лица – возможны совпадения.</p>
                </div>
            </div>
            <div v-if="!isNedoimkiError"  id="nedoimki">
                <i v-if="!isNedoimkiData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">НАЛОГОВАЯ ЗАДОЛЖЕННОСТЬ ФЛ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isNedoimkiData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="red">имеет</span> следующие задолженности по уплате налогов:
                </p>
                <p v-else-if="list.nedoimki.status == 'not valid'">{{list.nedoimki.message}}</p>
                <p v-else class="pdf__long-version__text">
                     По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="green">не имеет </span> задолженностей по уплате налогов.
                </p>
                <div v-if="isNedoimkiData">
                    <div v-for="(ned,i) in list.nedoimki.data" :key="i" class="pdf__long-version__box">
                        <p class="pdf__long-version__text" v-if="ned.name"><span class="pdf__long-version__text_bold">Тип налоговой задолженности: </span> {{ned.name}}</p>
                        <p class="pdf__long-version__text" v-if="ned.sum"><span class="pdf__long-version__text_bold">Сумма: </span> {{ned.sum}} руб</p>
                        <p class="pdf__long-version__text" v-if="ned.recipient_name"><span class="pdf__long-version__text_bold">Получатель задолженности: </span> {{ned.recipient_name}}</p>
                        <p class="pdf__long-version__text" v-if="ned.date_create"><span class="pdf__long-version__text_bold">Дата возникновения задолженности: </span> {{dateParser(ned.date_create)}}</p>
                    </div>
                    <p class="pdf__long-version__text_bold" style="font-size: 12px; margin: 30px 0 0 15px; text-decoration: underline">Общее количество налоговых задолженностей: {{list.nedoimki.data.length}}</p>
                    <p class="pdf__long-version__text_bold" style="font-size: 12px; margin: 0 0 30px 15px; text-decoration: underline">Общая сумма налоговой задолженности: {{getSum(list.nedoimki.data).toFixed(2)}} руб</p>
                </div>
            </div>
            <div v-if="!isPledgeError"  id="pledge">
                <i v-if="!isPledgeData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ЗАЛОГОВ ДВИЖИМОГО ИМУЩЕСТВА</h3>
                <hr style="margin: 10px 0 5px"/>
                <div v-if="isPledgeData">
                    <p class="pdf__long-version__text" >
                        По данным на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="red">имеет</span> следующие зарегистрированные залоги движимого имущества:
                    </p>
                    <template v-if="isPledgeData">
                        <div v-for="(pl,i) in list.pledge.data" :key="i" >
                            <p class="pdf__long-version__text" v-if="pl.notification_number">
                                <span class="pdf__long-version__text_bold">Номер уведомления: </span> {{pl.notification_number ? pl.notification_number : '—'}}
                            </p>
                            <p class="pdf__long-version__text" v-if="pl.date_reg">
                                <span class="pdf__long-version__text_bold">Дата уведомления: </span> {{pl.date_reg ? dateParser(pl.date_reg) : '—'}}
                            </p>
                            <div v-if="pl.pledgees && pl.pledgees.length">
                                <p class="pdf__long-version__text" v-if="pl.pledgees.length == 1">
                                    <span class="pdf__long-version__text_bold">Залогодержатель: </span> {{pl.pledgees[0].name ? pl.pledgees[0].name : '—'}}
                                </p>
                                <p class="pdf__long-version__text" v-if="pl.pledgees.length > 1">
                                    <span class="pdf__long-version__text_bold">Залогодержатели: </span>
                                </p>
                                <div v-if="pl.pledgees.length > 1" >
                                    <div v-for="(pled,i) in pl.pledgees" :key="i">
                                        <span>{{pled.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <p class="pdf__long-version__text" v-if="pl.notification_number">
                                <span class="pdf__long-version__text_bold">Номер договора: </span> {{pl.contract_number ? pl.contract_number : '—'}}
                            </p>
                            <p class="pdf__long-version__text" v-if="pl.date_reg">
                                <span class="pdf__long-version__text_bold">Дата договора: </span> {{pl.contract_date_start ? dateParser(pl.contract_date_start) : '—'}}
                            </p>
                            <p class="pdf__long-version__text" v-if="pl.date_reg">
                                <span class="pdf__long-version__text_bold">Срок исполнения обязательств по договору: </span> {{pl.contract_date_end ? dateParser(pl.contract_date_end) : '—'}}
                            </p>
                            <div v-if="pl.properties">
                                <p class="pdf__long-version__text" v-if="pl.properties.transport && pl.properties.transport.length">
                                    <span class="pdf__long-version__text_bold">Транспорт: </span>
                                </p>
                                <table v-if="pl.properties.transport && pl.properties.transport.length" class="pdf__long-version__table">
                                    <tr>
                                        <th>Номер имущества:</th>
                                        <th>Описание:</th>
                                        <th>Номер шасси (рамы):</th>
                                        <th>Номер кузова:</th>
                                    </tr>
                                    <tr v-for="(tr,i) in pl.properties.transport" :key="i">
                                        <td>{{tr.vin ? tr.vin : '—'}}</td>
                                        <td>{{tr.desc ? tr.desc : '—'}}</td>
                                        <td>{{tr.frameNum ? tr.frameNum : '—'}}</td>
                                        <td>{{tr.carBodyNum ? tr.carBodyNum : '—'}}</td>
                                    </tr>
                                </table>
                                <p class="pdf__long-version__text" v-if="pl.properties.other && pl.properties.other.length">Иное имущество: </p>
                                <table v-if="pl.properties.other && pl.properties.other.length" class="pdf__long-version__table">
                                    <tr>
                                        <th>Номер имущества:</th>
                                        <th>Описание:</th>
                                    </tr>
                                    <tr v-for="(oth,i) in pl.properties.other" :key="i">
                                        <td>{{oth.id ? oth.id : '—'}}</td>
                                        <td>{{oth.description ? oth.description : '—'}}</td>
                                    </tr>
                                </table>
                            </div>
                            <hr style="margin: 20px 0 15px 0;" v-if="i !== list.pledge.data.length - 1" />
                        </div>
                    </template>
                </div>
                <p v-else class="pdf__long-version__text">
                    По данным на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="green">не имеет</span> зарегистрированных залогов движимого имущества.
                </p>
            </div>
            <div v-if="!isDisqPersonError"  id="disq">
                <i v-if="!isDisqPersonData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ДИСКВАЛИФИЦИРОВАННЫХ ЛИЦ ФНС РОССИИ</h3>
                <hr style="margin: 10px 0 5px"/>
                <div v-if="isDisqPersonData">
                    <div v-for="(dis,i) in list.disq_person.data" :key="i" >
                        <p class="pdf__long-version__text" >
                            По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}}{{dis.birth_date ? `(${dateParser(dis.birth_date)}`: ''}}
                            {{dis.birth_place ? `, ${dis.birth_place})` : (dis.birth_date ? ')' : '')}} <span class="red">состоит</span>  в реестре дисквалифицированных лиц
                            и дисквалифицирован(а) с {{dateParser(dis.date_start)}} по {{dateParser(dis.date_stop)}} по {{dis.koap_code}}
                        </p>
                    </div>
                </div>
                <p v-else-if="list.disq_person.status == 'not valid'">{{list.disq_person.message}}</p>
                <p v-else class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span class="green">не состоит</span> в реестре дисквалифицированных лиц.
                </p>
            </div>
            <div v-if="!isRestrictOnPartUlErorr"  id="restrict">
                <i v-if="!isRestrictOnPartUlData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР ОГРАНИЧЕНИЙ УЧАСТИЯ В ЮЛ ФНС РОССИИ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(RestrictOnPartULDateUpdate)}} года {{nameOfPerson}} 
                    <span v-if="!isRestrictOnPartUlData" class="green">НЕ ИМЕЕТ</span>
                    <span v-else class="red">ИМЕЕТ</span> ограничения участия в ЮЛ.
                </p>
                <div v-if="isRestrictOnPartUlData">
                    <p class="pdf__long-version__text" >
                        Имеются ограничения участия в ЮЛ согласно 129-ФЗ от 08.08.2001 (статья 23, пункт 1, подпункт "ф") в виде отказа в государственной регистрации 
                        если в регистрирующий орган представлены документы для включения сведений об учредителе (участнике) ЮЛ либо о лице, имеющем право без доверенности 
                        действовать от имени ЮЛ.
                    </p>
                    <div v-for="(rest,i) in formattedList" :key="i" style="padding-bottom: 10px" >
                        <p class="pdf__long-version__text"><span class="pdf__long-version__text_bold">Причастность лица к ЮЛ:</span> {{rest.implication}} <a :href="`${window.location.origin}/company/${rest.ogrn_ul}`" target='_blank'>{{rest.ul_name}}</a></p>
                        <p class="pdf__long-version__text"><span class="pdf__long-version__text_bold">Причина ограничения:</span> {{rest.restrict_reason}}</p> 
                        <p class="pdf__long-version__text"><span class="pdf__long-version__text_bold">Срок действия ограничение:</span> с {{dateParser(rest.date_start)}} по {{dateParser(rest.date_end)}}</p>
                    </div>
                </div>
                <p v-else-if="list.restrict_on_part_ul.status == 'not valid'">{{list.restrict_on_part_ul.message}}</p>
            </div>
            <div v-if="!isCheckIpError"  id="ip">
                <i v-if="isCheckIpData" class="fas fa-plus"></i>
                <i v-else class="fas fa-minus"></i>
                <h3 class="pdf__long-version__sub-header">НАЛИЧИЕ СТАТУСА ИП</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isCheckIpData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600">зарегистрирован(а)</span> в качестве индивидуального предпринимателя.
                </p>
                <p v-else-if="list.check_ip.status == 'not valid'">{{list.check_ip.message}}</p>
                <p v-else class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600">не зарегистрирован(а)</span> в качестве индивидуального предпринимателя.
                </p>
                <div v-if="isCheckIpData">
                    <div v-for="(ip,i) in list.check_ip.data" :key="i" class="pdf__long-version__box" style="margin-bottom: 0px">
                        <p class="pdf__long-version__text" v-if="ip.ogrn">
                            <span class="pdf__long-version__text_bold">ОГРНИП: </span>
                            <a :href="`${window.location.origin}/person/${ip.ogrn}`" target="_blank">{{ip.ogrn}}</a>
                        </p>
                        <p class="pdf__long-version__text" v-if="ip.fns_status"><span class="pdf__long-version__text_bold">Статус ФНС: </span> {{ip.fns_status}}</p>
                        <p class="pdf__long-version__text" v-if="ip.date_start"><span class="pdf__long-version__text_bold">Дата регистрации: </span> {{dateParser(ip.date_start)}}</p>
                        <p class="pdf__long-version__text" v-if="ip.date_stop"><span class="pdf__long-version__text_bold">Дата ликвидации: </span> {{dateParser(ip.date_stop)}}</p>
                        <p class="pdf__long-version__text" v-if="ip.okved_title"><span class="pdf__long-version__text_bold">Основной вид деятельности: </span> {{ip.okved_title}}</p>
                        <p class="pdf__long-version__text" v-if="ip.reg_org && ip.reg_org.name"><span class="pdf__long-version__text_bold">Регистрационный орган: </span> {{ip.reg_org.name}}</p>
                        <p class="pdf__long-version__text" v-if="ip.pf">
                            <span class="pdf__long-version__text_bold">Регистрация в Пенсионном фонде: </span> 
                            {{ip.pf.issuer ? ip.pf.issuer : ''}}
                            {{ip.pf.date ? `(${ip.pf.date})` : ''}}
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="!isSelfEmployedError"  id="employed">
                <i v-if="isSelfEmployedData" class="fas fa-plus"></i>
                <i v-else class="fas fa-minus"></i>
                <h3 class="pdf__long-version__sub-header">НАЛИЧИЕ СТАТУСА САМОЗАНЯТОГО</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isSelfEmployedData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600">ЯВЛЯЕТСЯ</span> плательщиком налога на профессиональный доход (<span style="text-transform: uppercase; font-weight: 600">ИМЕЕТ</span> статус самозанятого)
                </p>
                <p v-else class="pdf__long-version__text">
                   По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600"> НЕ ЯВЛЯЕТСЯ</span> плательщиком налога на профессиональный доход (<span style="text-transform: uppercase; font-weight: 600">НЕ ИМЕЕТ</span> статус самозанятого)
                </p>
                <p v-if="isSelfEmployedData" class="pdf__long-version__text_tip">При работе ЮЛ с данным ФЛ не нужно удерживать НДФЛ и начислять на его вознаграждение страховые взносы. Чеки, сформированные самозанятым, ЮЛ может учитывать в своих расходах.</p>
            </div>
            <div v-if="!isMassPersonError"  id="mass_upr">
                <i v-if="!isMassPersonUprData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР МАССОВЫХ РУКОВОДИТЕЛЕЙ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isMassPersonUprData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span class="red">состоит</span> 
                    в реестре массовых руководителей и является руководителем {{list.mass_person.data.mass_upr.amount}} организаций.
                </p>
                <p v-else-if="list.mass_person.status == 'not.valid'">{{list.mass_person.message}}</p>
                <p v-else class="pdf__long-version__text">По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}}  <span class="green"> не состоит</span> в реестре массовых руководителей.</p>
            </div>
            <div v-if="!isMassPersonError"  id="mass_uchr">
                <i v-if="!isMassPersonUchrData" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
                <h3 class="pdf__long-version__sub-header">РЕЕСТР МАССОВЫХ УЧРЕДИТЕЛЕЙ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isMassPersonUchrData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} 
                    <span class="red">состоит</span> 
                    в реестре массовых учредителей и является учредителем {{list.mass_person.data.mass_uchr.amount}} организаций.
                </p>
                <p v-else-if="list.mass_person.status == 'not.valid'">{{list.mass_person.message}}</p>
                <p v-else class="pdf__long-version__text">По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}}  <span class="green"> не состоит</span> в реестре массовых учредителей.</p>
            </div>
            <div v-if="!isAffilError" id="affil">
                <i v-if="!isAffilError && isAffilData" class="fas fa-plus"></i>
                <i v-else class="fas fa-minus"></i>
                <h3 class="pdf__long-version__sub-header">АФФИЛИРОВАННЫЕ ОРГАНИЗАЦИИ</h3>
                <hr style="margin: 10px 0 5px"/>
                <p v-if="isAffilData" class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600">имеет</span> следующие аффилированные с ним(ней) организации:
                </p>
                <p v-else-if="list.affil.status == 'not valid'">{{list.affil.message}}</p>
                <p v-else class="pdf__long-version__text">
                    По данным ФНС РОССИИ на {{dateParser(dateCheck)}} года {{nameOfPerson}} <span style="text-transform: uppercase; font-weight: 600">не имеет</span> аффилированных с ним(ней) организаций.
                </p>
                <div v-if="isAffilGraphicsData && list.affil.graphics.code === 0">
                    <h3 class="pdf__long-version__sub-header">Схема аффилированности</h3>
                    <flAfil
                        v-if="list.affil && list.affil.graphics && list.affil.graphics.data && list.affil.graphics.data.nodes && list.affil.graphics.data.nodes.length"
                        :fl-afil-data="list.affil.graphics.data"
                    />
                </div>
                <div v-if="isAffilTableData && list.affil.table.code === 0">
                    <h3 class="pdf__long-version__sub-header">Аффилированность</h3>
                    <div v-if="list.affil.table && list.affil.table.data.upr && list.affil.table.data.upr.length" class="pdf__long-version__box">
                        <p class="pdf__long-version__table-description" v-if="list.affil.table.data.upr && list.affil.table.data.upr.length">Является/являлся руководителем (совпадение по ИНН)</p>
                        <table v-if="list.affil.table.data.upr && list.affil.table.data.upr.length" class="pdf__long-version__table">
                            <thead>
                                <th>ИНН</th>
                                <th>Наименование</th>
                                <th>Период</th>
                                <th>Адрес</th>
                            </thead>
                            <tbody v-for="(up, i) in list.affil.table.data.upr" :key="i">
                                <td>{{up.inn ? up.inn : '—'}}</td>
                                <td>
                                    <i v-if="up.status_type[0] == 1 || up.status_type[0] == 3" class="fas fa-check-circle"></i>
                                    <i v-else-if="up.status_type[0] == 0" class="fas fa-times-circle"></i>
                                    <i v-else-if="up.status_type[0] == 2" class="fas fa-minus-circle"></i>
                                    <a v-if="up.ogrn" :href="`${window.location.origin}/company/${up.ogrn}`" target="_blank">{{up.name_short ? up.name_short : (up.name_full ? up.name_full : '—')}}</a>
                                    <span v-else>{{up.name_short ? up.name_short : (up.name_full ? up.name_full : '—')}}</span>
                                </td>
                                <td>{{up.stakeholder_type && up.stakeholder_type !== "HISTORY" && !up.date_stop ? 'по н.в' : `по ${up.stakeholder_date_end ? dateParser(up.stakeholder_date_end) : up.date_stop ? dateParser(new Date(up.date_stop.toString().slice(0, 4), up.date_stop.toString().slice(4, 6) - 1, up.date_stop.toString().slice(6))) : '-'}`}}</td>
                                <td>{{up.addr_full ? up.addr_full : '—'}}</td>
                            </tbody>
                        </table>
                        <span class="pdf__long-version__text_bold">Всего: {{list.affil.table.data.upr.length}}</span><br/>
                        <span class="pdf__long-version__text_bold">Действующие: {{list.affil.table.data.upr.filter(a => a.status_type[0] == 1 || a.status_type[0] == 3).length}}</span>
                        <span class="pdf__long-version__text_bold">Ликвидированные: {{list.affil.table.data.upr.filter(a => a.status_type[0] == 0).length}}</span>
                        <span class="pdf__long-version__text_bold">Находятся в стадии ликвидации: {{list.affil.table.data.upr.filter(a => a.status_type[0] == 2).length}}</span><br>
                        <span class="pdf__long-version__text_bold"><b>Действующий руководитель: </b> {{currentStakeholder(list.affil.table.data.upr).length}}</span>
                        <span class="pdf__long-version__text_bold"><b>Бывший руководитель: </b> {{list.affil.table.data.upr.length - currentStakeholder(list.affil.table.data.upr).length}}</span>
                    </div>
                    <div v-if="list.affil.table && list.affil.table.data.uchr && list.affil.table.data.uchr.length" class="pdf__long-version__box">
                        <p class="pdf__long-version__table-description" v-if="list.affil.table.data.uchr && list.affil.table.data.uchr.length">Является/являлся учредителем (совпадение по ИНН)</p>
                        <table v-if="list.affil.table.data.uchr && list.affil.table.data.uchr.length" class="pdf__long-version__table">
                            <thead>
                                <th>ИНН</th>
                                <th>Наименование</th>
                                <th>Период</th>
                                <th>Адрес</th>
                            </thead>
                            <tbody v-for="(uch, i) in list.affil.table.data.uchr" :key="i">
                                <td>{{uch.inn ? uch.inn : '—'}}</td>
                                <td>
                                     <i v-if="uch.status_type[0] == 1 || uch.status_type[0] == 3" class="fas fa-check-circle"></i>
                                    <i v-else-if="uch.status_type[0] == 0" class="fas fa-times-circle"></i>
                                    <i v-else-if="uch.status_type[0] == 2" class="fas fa-minus-circle"></i>
                                    <a v-if="uch.ogrn" :href="`${window.location.origin}/company/${uch.ogrn}`" target="_blank">{{uch.name_short ? uch.name_short : (uch.name_full ? uch.name_full : '—')}}</a>
                                    <span v-else>{{uch.name_short ? uch.name_short : (uch.name_full ? uch.name_full : '—')}}</span>
                                </td>
                                <td>{{uch.stakeholder_type && uch.stakeholder_type !== "HISTORY" && !uch.date_stop ? 'по н.в' : `по ${uch.stakeholder_date_end ? dateParser(uch.stakeholder_date_end) : uch.date_stop ? dateParser(new Date(uch.date_stop.toString().slice(0, 4), uch.date_stop.toString().slice(4, 6) - 1, uch.date_stop.toString().slice(6))) : '-'}`}}</td>
                                <td>{{uch.addr_full ? uch.addr_full : '—'}}</td>
                            </tbody>
                        </table>
                        <span class="pdf__long-version__text_bold">Всего: {{list.affil.table.data.uchr.length}}</span><br/>
                        <span class="pdf__long-version__text_bold">Действующие: {{list.affil.table.data.uchr.filter(a => a.status_type[0] == 1 || a.status_type[0] == 3).length}}</span>
                        <span class="pdf__long-version__text_bold">Ликвидированные: {{list.affil.table.data.uchr.filter(a => a.status_type[0] == 0).length}}</span>
                        <span class="pdf__long-version__text_bold">Находятся в стадии ликвидации: {{list.affil.table.data.uchr.filter(a => a.status_type[0] == 2).length}}</span><br>
                        <span class="pdf__long-version__text_bold"><b>Действующий учредитель: </b> {{currentStakeholder(list.affil.table.data.uchr).length}}</span>
                        <span class="pdf__long-version__text_bold"><b>Бывший учредитель: </b> {{list.affil.table.data.uchr.length - currentStakeholder(list.affil.table.data.uchr).length}}</span>
        
                    </div>
                </div>    
                <div v-if="isAffilFlHistoryData && list.affil.fl_history.code === 0">
                    <h3 class="pdf__long-version__sub-sub-header ">Исторические связи</h3>
                    <div v-if="list.affil.fl_history && list.affil.fl_history.data && list.affil.fl_history.data.ul && list.affil.fl_history.data.ul.length" class="pdf__long-version__box">
                        <p class="pdf__long-version__table-description" v-if="list.affil.fl_history.data && list.affil.fl_history.data.ul && list.affil.fl_history.data.ul.length">Исторические связи</p>
                        <table v-if="list.affil.fl_history.data && list.affil.fl_history.data.ul && list.affil.fl_history.data.ul.length" class="pdf__long-version__table">
                            <thead>
                                <th>ИНН</th>
                                <th>Наименование</th>
                                <th>Период</th>
                                <th>Адрес</th>
                            </thead>
                            <tbody v-for="(his, i) in list.affil.fl_history.data.ul" :key="i">
                                <td>{{his.inn ? his.inn : '—'}}</td>
                                <td>
                                    <i v-if="his.status == 1 || his.status == 3" class="fas fa-check-circle"></i>
                                    <i v-else-if="his.status == 0" class="fas fa-times-circle"></i>
                                    <i v-else-if="his.status == 2" class="fas fa-minus-circle"></i>
                                    <a v-if="his.ogrn" :href="`${window.location.origin}/company/${his.ogrn}`" target="_blank">{{his.name_short ? his.name_short : (his.name_full ? his.name_full : '—')}}</a>
                                    <span v-else>{{his.name_short ? his.name_short : (his.name_full ? his.name_full : '—')}}</span>
                                </td>
                                <td>{{his.year ? his.year : '—'}}</td>
                                <td>{{his.address ? his.address : '—'}}</td>
                            </tbody>
                        </table>
                        <span class="pdf__long-version__text_bold">Всего: {{list.affil.fl_history.data.ul.length}}</span><br/>
                        <span class="pdf__long-version__text_bold">Действующие: {{list.affil.fl_history.data.ul.filter(a => a.status == 1 || a.status == 3).length}}</span>
                        <span class="pdf__long-version__text_bold">Ликвидированные: {{list.affil.fl_history.data.ul.filter(a => a.status == 0).length}}</span>
                        <span class="pdf__long-version__text_bold">Находятся в стадии ликвидации: {{list.affil.fl_history.data.ul.filter(a => a.status == 2).length}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { htmlStringToPrint, downloadBinaryFile, translit, Base64 } from "@/helpers.ts"
import flAfil from './flAfil.vue'
import corpIcon from '@/components/ui/corpIcon.vue'

export default {
    props:[
        'dateCheck',
        'list',
        'upload',
        'name',
        'surname',
        'patronymic',
        'birthday',
        'serial',
        'number',
        'inn',
        'inputInn'
    ],
    components: {
        flAfil,
        corpIcon
    },
    data() {
        return {
            show: false
        }
    },
    mounted() {
        if(this.$props.upload && typeof(this.$props.list) == 'object' && Object.values(this.$props.list).length) {
            setTimeout(() => {
                this.getPdf()
                document.querySelector(".fl-pdf").style.display = "none"
            }, 2000)
        } else {
            this.$store.commit('flCheck/setUpload', false)
            this.$store.commit('flCheck/setLoading', false)
        }
    },
    computed: {
        nameOfPerson() { return `${this.$props?.surname ? this.capitalize(this.$props.surname) : ''} ${this.$props?.name ? this.capitalize(this.$props.name) : ''} ${this.$props?.patronymic ? this.capitalize(this.$props.patronymic) : ''}` },
        formattedList() { return this.getFormattedList(this.$props?.list.restrict_on_part_ul?.data?.list) },

        //Проверка на доступность данных
        //passports
        isPassportsError() { return !this.$props.list?.passports || this.$props.list?.passports?.code !== 0 },
        isPassportsData() { return this.$props.list?.passports?.data?.passports },
        //check_inn
        isCheckInnError() { return !this.$props.list?.check_inn || this.$props.list?.check_inn?.code !== 0 },
        checkInnCode() { return this.$props.list?.check_inn?.data?.code },
        //fed_rozysk
        isFedRozyskError() { return !this.$props.list?.fed_rozysk || this.$props.list?.fed_rozysk?.code !== 0 },
        isFedRozyskData() { return this.$props.list?.fed_rozysk?.data?.find_obj?.length },
        //terrorists
        isTerroristsError() { return !this.$props.list?.terrorists?.data || this.$props.list?.terrorists?.code !== 0 },
        isTerroristsData() { return this.$props.list?.terrorists?.data?.terrorists?.length },
        //fsin
        isFsinError() { return ! this.$props.list?.fsin || this.$props.list?.fsin?.code !== 0 },
        isFsinData() { return this.$props.list?.fsin?.data?.length },
        //fssp_fl_rozysk_yk
        isFsspFlRozyskYkError() { return !this.$props?.list.fssp_fl_rozysk_yk || this.$props?.list.fssp_fl_rozysk_yk?.data?.status === 1 || this.$props?.list.fssp_fl_rozysk_yk?.code !== 0 },
        isFsspFlRozyskYkData() { return this.$props.list?.fssp_fl_rozysk_yk?.data?.length },
        //fssp_fl_rozysk_ip
        isFsspFlRozyskIpError() { return !this.$props.list?.fssp_fl_rozysk_ip || this.$props.list?.fssp_fl_rozysk_ip?.data?.status === 1 || this.$props.list?.fssp_fl_rozysk_ip?.code !== 0 },
        isFsspFlRozyskIpData() { return this.$props.list?.fssp_fl_rozysk_ip?.data?.result?.length },
        //fssp_fl_ip
        isFsspFlIpError() { return !this.$props.list?.fssp_fl_ip || this.$props.list?.fssp_fl_ip?.data?.status === 1 || this.$props.list?.fssp_fl_ip?.code !== 0  },
        isFsspFlIpData() { return this.$props.list?.fssp_fl_ip?.data?.result?.length },
        //bankrupt
        isBankruptError() { return !this.$props.list?.bankrupt || this.$props.list?.bankrupt?.code !== 0 },
        isBankruptData() { return Object.values(this.$props.list?.bankrupt?.data ?? {}).length },
        //dismissed_person
        isDismissedPersonError() { return ! this.$props.list?.dismissed_person || this.$props.list?.dismissed_person?.code !== 0 },
        isDismissedPersonData() { return this.$props.list?.dismissed_person?.data?.length },
        //nedoimki
        isNedoimkiError() { return !this.$props.list?.nedoimki || this.$props.list?.nedoimki?.code !== 0 },
        isNedoimkiData() { return this.$props.list?.nedoimki?.data?.length },
        //pledge
        isPledgeError() { return !this.$props.list?.pledge || this.$props.list?.pledge?.code !== 0 },
        isPledgeData() { return this.$props.list?.pledge?.data?.length },
        //disq_person
        isDisqPersonError() { return !this.$props.list?.disq_person || this.$props.list?.disq_person?.code !== 0 },
        isDisqPersonData() { return this.$props.list?.disq_person?.data?.length },
        //restrict_on_part_ul
        isRestrictOnPartUlErorr() { return !this.$props.list?.restrict_on_part_ul || this.$props.list?.restrict_on_part_ul?.code !== 0 },
        isRestrictOnPartUlData() { return this.$props.list?.restrict_on_part_ul?.data?.list?.length },
        RestrictOnPartULDateUpdate() { return this.$props.list?.restrict_on_part_ul?.data?.date_update ?? dateCheck},
        //check_ip
        isCheckIpError() { return !this.$props.list?.check_ip || this.$props.list?.check_ip?.code !== 0 },
        isCheckIpData() { return this.$props.list?.check_ip?.data?.length },
        //self_employed
        isSelfEmployedError() { return !this.$props.list?.self_employed || this.$props.list?.self_employed?.code !== 0 },
        isSelfEmployedData() { return this.$props.list?.self_employed?.data?.status },
        //mass_person
        isMassPersonError() { return !this.$props.list?.mass_person || this.$props.list?.mass_person?.code !== 0  },
        isMassPersonUprData() { return this.$props.list?.mass_person?.data?.mass_upr?.status },
        isMassPersonUchrData() { return this.$props.list?.mass_person?.data?.mass_uchr?.status },
        //affil
        isAffilError() { return !(this.$props.list.affil?.table?.code === 0 || this.$props.list.affil?.fl_history?.code === 0 || this.$props.list.affil?.graphics?.code === 0)},
        isAffilTableData() { return this.$props.list?.affil?.table?.data?.upr?.length || this.$props.list?.affil?.table?.data?.uchr?.length },
        isAffilGraphicsData() { return this.$props.list?.affil?.graphics?.data?.nodes?.length },
        isAffilFlHistoryData() { return this.$props.list?.affil?.fl_history?.data?.ul?.length } ,
        isAffilData() {return this.isAffilTableData || this.isAffilGraphicsData || this.isAffilFlHistoryData}   
    },
    methods: {
        currentStakeholder(afil) {
            if(afil.type !== 'HISTORY') {
                return afil.filter(e => e.stakeholder_type ? e.stakeholder_type === 'CURRENT' && !Number.isInteger(e.date_stop) : false)
            } else if(afil.type === 'HISTORY') {
                return []
            }
        },
        dateParser(date) {
            const reg = /^\d{2}\.\d{2}\.\d{4}$/gm
            if(reg.test(date)) return date
            return new Date(date).toLocaleDateString('ru')
        },
        getPdf(){
            const styleFL = `
                #print-pdf-hint { display: none } 
                .no_print {display: none !important}
                .no_print-pre {white-space: pre-line;}
                .bold__date{font-weight: bold;} 
                .fl-pdf{display: block} 
                .pdf__article{border-bottom: 1.5px solid black} 
                .pdf__header {height: 32px; line-height: 32px; text-align: left; padding: 0 15px; border-radius: 3px; margin: 20px 0 5px; font-weight: 500; background-color: #4770F3; color: #FEFEFE; display: inline-block;font-size: 14px}
                p{margin: 10px 0}
                .pdf__article__text {font-size: 14px;font-weight: 600;color: #4771f3;text-align: center}
                .pdf__main-info {margin-top: 10px}
                .pdf__main-info__text {font-size: 14px; }
                .pdf__main-info__text_bold {font-weight: 600; }
                .pdf__short-version__text {font-size: 14px;text-decoration: underline; color: black; margin-bottom: 15px; display: block}
                .pdf__long-version__sub-header {margin-top: 10px;font-size: 14px;color: #4771f3;font-weight: 600; margin-top: 50px; }
                .pdf__long-version__text {font-size: 14px; }
                .pdf__long-version__text_tip {font-size: 12px; }
                .pdf__long-version__text_bold {font-weight: 600; }
                .pdf__long-version__box {font-size: 14px;margin: 30px 0 30px 15px; }
                .pdf__long-version__table {font-size: 14px;width: 100%; }
                .pdf__long-version__table th {font-weight: 600; text-align: left; padding: 0 10px; }
                .pdf__long-version__table td {padding: 0 10px; }
                .pdf__long-version__table tbody {border-bottom: 1px solid #ddd; text-align: left; padding: 8px}
                .pdf__long-version__table-description {font-size: 14px;font-weight: 500;color: #4771f3;border-bottom: 1px solid #4771f3; }
                .fa-minus-circle { color: #e7843c;font-size: 14px;margin-right: 5px }
                .fa-minus, .fa-times, .fa-times-circle {font-size: 14px;margin-right: 5px;color: #e74c3c; }
                .fa-plus, .fa-check, .fa-check-circle {margin-right: 5px;font-size: 14px;color: #2ecc71; }
                .green {color: #2ecc71;text-transform: uppercase;font-weight: 600; }
                .red {color: #e74c3c;text-transform: uppercase;font-weight: 600; }
                p {margin: 10px 0 10px 0}
                .hidden {display: none}
                .grey {color: #999999}
                h3 {display: inline-block}
                #afil-legend .legend__line-through {position: absolute;width: 95%;height: 3px;background-color: #888;top: 14px;z-index: 12;}
                #afil-legend .afil-legend-edge {width: 90px;margin-right: 10px;display: inline-block;vertical-align: middle;border-top-width: 3px;border-color: #ccc;border-style: solid;position: relative;}
                #afil-legend .afil-legend-edge__text {position: absolute;left: 0;top: -14px;font-size: 10px;width: 100%;text-align: center;}
                #afil-legend .afil-legend-edge__upr {border-color: #2d82ba;}
                #afil-legend .afil-legend-edge__lupr {border-color: #2d82ba;border-style: dashed;}
                #afil-legend .afil-legend-edge__luchr, #afil-legend .afil-legend-edge__predsh, #afil-legend .afil-legend-edge__preem {border-style: dashed;}
                #afil-legend .status-color-block {width: 22px;height: 14px;margin-right: 3px;display: inline-block;position: relative;top: 2px;}
                #afil-legend .status-color-block__green {background-color: #32cd74;}
                #afil-legend .status-color-block__orange {background-color: #e78640;}
                #afil-legend .status-color-block__red {background-color: #e85749;}
                #afil-legend .fa {font-family: "FontAwesome";display: inline-block;width: 25px;text-align: center;font-weight: normal;color: #9b9b9b;font-size: 22px;position: relative;top: 2px;}
                #afil-legend {background-color: #fff;border-radius: 5px;padding: 10px;z-index: 1;font-size: 0;width: 700px;margin: 0 auto;}
                #afil-legend ul {font-size: 12px;display: inline-block;vertical-align: top;padding: 0;margin: 0;width: 50%;}
                #afil-legend > ul > li::selection, #afil-legend > ul > li div::selection {background-color: transparent;color: #333;}
                #afil-legend > ul > li {cursor: pointer;line-height: 26px;padding: 2px 5px;position: relative;}
                #afil-legend > ul > li > div {display: inline-block;}
                #afil-legend > ul > li:hover {background-color: rgba(0, 0, 0, 0.1);}
            `
            const headerText = 'Онлайн-проверка ФЛ'
            const imgHtmlCode = htmlStringToPrint(headerText, this.$refs.htmlBody.outerHTML, styleFL)

            let name = this.$props.name ? `_${translit(this.$props.name)}` : ''
            let surname = this.$props.surname ? `_${translit(this.$props.surname)}` : ''
            let patronymic = this.$props.patronymic ? `_${translit(this.$props.patronymic)}` : ''

            const fio = surname + name + patronymic
            const inn = this.$props.inn ? `_${this.$props.inn}` : ''

            const filename = `checkFl${fio || inn}`

            this.$store.dispatch('flCheck/getPdf', {imgHtmlCode, filename})
        },
        getRegionByInn(inn) {
            const regions = {
                "14":"Республика Саха(Якутия)",
                "32":"Брянская область",
                "77":"Москва",
                "89":"Ямало-Ненецкий АО",
                "33":"Владимирская область",
                "50":"Московская область",
                "59":"Пермский край",
                "74":"Челябинская область",
                "76":"Ярославская область",
                "25":"Приморский край",
                "60":"Псковская область",
                "53":"Новгородская область",
                "24":"Красноярский край",
                "26":"Ставропольский край",
                "46":"Курская область",
                "66":"Свердловская область",
                "61":"Ростовская область",
                "63":"Самарская область",
                "34":"Волгоградская область",
                "23":"Краснодарский край",
                "78":"Санкт-Петербург",
                "22":"Алтайский край",
                "70":"Томская область",
                "31":"Белгородская область",
                "27":"Хабаровский край",
                "41":"Камчатский край",
                "35":"Вологодская область",
                "05":"Республика Дагестан",
                "01":"Республика Адыгея",
                "47":"Ленинградская область",
                "69":"Тверская область",
                "73":"Ульяновская область",
                "65":"Сахалинская область",
                "51":"Мурманская область",
                "43":"Кировская область",
                "62":"Рязанская область",
                "10":"Республика Карелия",
                "86":"Ханты-Мансийский - Югра АО",
                "16":"Республика Татарстан",
                "07":"Республика Кабардино-Балкарская",
                "19":"Республика Хакасия",
                "56":"Оренбургская область",
                "67":"Смоленская область",
                "64":"Саратовская область",
                "54":"Новосибирская область",
                "28":"Амурская область",
                "15":"Республика Северная Осетия - Алания",
                "30":"Астраханская область",
                "38":"Иркутская область",
                "29":"Архангельская область",
                "09":"Республика Карачаево-Черкесская",
                "08":"Республика Калмыкия",
                "06":"Республика Ингушетия",
                "58":"Пензенская область",
                "02":"Республика Башкортостан",
                "55":"Омская область",
                "68":"Тамбовская область",
                "42":"Кемеровская область",
                "18":"Республика Удмуртская",
                "39":"Калининградская область",
                "36":"Воронежская область",
                "03":"Республика Бурятия",
                "04":"Республика Алтай",
                "52":"Нижегородская область",
                "49":"Магаданская область",
                "40":"Калужская область",
                "37":"Ивановская область",
                "48":"Липецкая область",
                "71":"Тульская область",
                "79":"Еврейская АО",
                "72":"Тюменская область",
                "57":"Орловская область",
                "12":"Республика Марий Эл",
                "44":"Костромская область",
                "82":"Корякский АО",
                "75":"Читинская область",
                "45":"Курганская область",
                "80":"Агинский Бурятский АО",
                "13":"Республика Мордовия",
                "17":"Республика Тыва",
                "21":"Чувашская Республика - Чувашия",
                "81":"Коми-Пермяцкий АО",
                "83":"Ненецкий АО",
                "20":"Республика Чеченская",
                "11":"Коми Республика",
                "85":"Усть-Ордынский Бурятский АО",
                "88":"Эвенкийский АО",
                "87":"Чукотский АО",
                "84":"Таймырский АО",
                "91":"Республика Крым",
                "92":"Севастополь"
            }
            let code = inn.slice(0,2)

            return regions[code]
        },
        getSum(data, type) {
            if(type == 'ip') {
                let sum = 0
                data.forEach(element => {
                    sum += element.summ
                })
                return sum
            } else {
                let sum = 0
                data.forEach(element => {
                    sum += parseFloat(element.sum)
                })
                return sum
            }
        },
        getFormattedList(list) {
            let arr = []

            list.forEach(el => {
                if(arr.some(e => e.ogrn_ul == el.ogrn_ul) && arr.indexOf(el) == -1) {
                    let elem = arr.find(a => a.ogrn_ul == el.ogrn_ul)
                    let index = arr.indexOf(elem)
                    arr[index].implication = `${arr[index].implication}/${el.implication}`
                }else {
                    arr.push(el)
                }
            })

            return arr
        }
    }
}
</script>


<style lang="sass" scoped>
@import "styles/global-variables.sass"
    
table
    @extend .simple-table

.fl-pdf
    visibility: hidden

.pdf
    &__header
        width: 100%
        height: 32px
        line-height: 32px
        text-align: left
        padding: 0 15px
        border-radius: 3px
        margin: 5px 0
        font-weight: 500
        background-color: #4770F3
        color: #FEFEFE
        display: inline-block
        font-size: 14px
    &__article
        border-bottom: 1.5px solid black
        &__text
            font-size: 12px
            font-weight: 600
            color: #4771f3
            text-align: center
    &__main-info
        margin-top: 40px
        &__header
            width: 170px
            font-size: 14px
            background-color: #4771f3
            color: #fff
            font-weight: 600
        &__text
            font-size: 12px
            &_bold
                font-weight: 600
    &__short-version
        &__header
            width: 260px
            font-size: 14px
            background-color: #4771f3
            color: #fff
            font-weight: 600
        &__text
            margin-bottom: 15px
            font-size: 12px
            text-decoration: none
            color: black
    &__long-version
        &__header
            width: 350px
            font-size: 14px
            background-color: #4771f3
            color: #fff
            font-weight: 600
            margin: 50px 0 25px
        &__sub-header
            margin-top: 50px
            font-size: 12px
            color: #4771f3
            font-weight: 600
        &__text
            font-size: 12px
            &_bold
                font-weight: 600
        &__box
            font-size: 12px
            margin: 30px 0 30px 15px
        &__table
            font-size: 12px
            width: 50%
            th
                font-weight: 600
                border: 1px dotted #4771f3
            td
               border: 1px dotted #4771f3 
        &__table-description
            font-size: 12px
            font-weight: 500
            color: #4771f3
            border-bottom: 1px solid #4771f3


.fa-times
    font-size: 12px
    margin-right: 5px
    color: rgb(231, 76, 60)
.fa-check
    margin-right: 5px
    font-size: 12px
    color: rgb(46, 204, 113)
.green
    color: rgb(46, 204, 113)
    text-transform: uppercase
    font-weight: 600
.red
    color: rgb(231, 76, 60)
    text-transform: uppercase
    font-weight: 600
.grey
    color: #999999
p
    margin: 10px 0 10px 0
.hidden
    display: none
</style>
